import { Injectable } from '@angular/core';


interface ExecuteWithCacheOptions<T> {
    networkFirst: boolean;
    resourceKey: string;
    params?: unknown;
    resourceFn: () => Promise<T>;
}

@Injectable({
    providedIn: 'root',
})
    

export class WclCacheProxyService {
    async executeWithCache<T>(options: ExecuteWithCacheOptions<T>): Promise<T> {
        const { networkFirst, resourceKey, params, resourceFn } = options;
        const cacheKey = this.buildCacheKey(resourceKey, params);
        // cacheKey is rebuilt here to ensure that the cache key is unique for each set of parameters
        // i.e getting loan offer with ref 'abc' and getting loan offer with ref 'def' should not return the same cached data

        if (!networkFirst) {
            const cachedData = this.getFromCache<T>(cacheKey);
            if (cachedData) {
                return cachedData;
            }
        }

        const result = await resourceFn();
        this.saveToCache(cacheKey, result);
        return result;
    }

    clearCache(key: string, params?: unknown): void {
        const cacheKey = this.buildCacheKey(key, params);
        localStorage.deleteItem(cacheKey);
    }

    private buildCacheKey(key: string, params?: unknown): string {
        // ensure that the cache key is unique for each set of parameters
        const paramKey = params ? JSON.stringify(params) : 'default';
        return `wcl_cache_${key}_${paramKey}`;
    }

    private getFromCache<T>(cacheKey: string): T | null {
        const cached = sessionStorage.getItem(cacheKey);
        if (!cached) return null;

        try {
            const parsedCache = JSON.parse(cached);

            return parsedCache.data;
        } catch {
            return null;
        }
    }

    private saveToCache<T>(cacheKey: string, data: T): void {
        const cacheData = {
            data,
            timestamp: Date.now(), // store the timestamp to enable cache invalidation later if needed - #TODO
        };
        sessionStorage.setItem(cacheKey, JSON.stringify(cacheData));
    }
}